
import React, { useState, useEffect, useRef } from "react";
// import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import ImageWithBasePath from '../../core/img/imagewithbasebath';
import Axios from 'axios';
import { API_BASE_URL, GET_PO_BY_ID, GET_SUP_STO_DATA } from "../../Config";
import {  useParams } from "react-router-dom";
// import jsPDF from 'jspdf';
// import html2canvas from 'html2canvas';
// import 'jspdf-autotable';
import html2pdf from "html2pdf.js";
import logo from './41115.png';
import SpinLoader from "../loader/SpinLoader";



const ViewDataToSupplier = () => {

    const { PurchaseId } = useParams();
    const [loading, setLoading] = useState(false);
    const [viewData, setViewData] = useState([]);
    const [firstData, setFirstData] = useState([]);
    const [storeSupData, setStoreSupData] = useState([]);
    const [formattedDate, setFormattedDate] = useState('');
    const contentRef = useRef(null);
    const [totalAmount, setTotalAmount] = useState("");
    const [taxAmount, setTaxAmount] = useState("");
    const [totalQty, setTotalQty] = useState("");
    const [amountWithOutDis, setAmountWithOutDis] = useState("");
    // const [currentDate, setCurrentDate] = useState("");

    // const isMobile = window.innerWidth <= 768; 

    useEffect(() => {
        console.log("PurchaseId:", PurchaseId);
    }, [PurchaseId]);

    useEffect(() => {
        if (PurchaseId){
            setLoading(true);
            const url = `${API_BASE_URL}${GET_PO_BY_ID}?&PurchaseId=${PurchaseId}`;
            Axios.get(url)
                .then(response => {
                    if (response.data.Status) {
                        setViewData(response.data.ResultData);
                        setFirstData(response.data.ResultData[0]);
                        setLoading(false);
                        console.log(response.data.ResultData, 'req details');
                    } else {
                        console.error('Error fetching data:', response.data.Message);
                        setLoading(false);
                    }
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                    setLoading(false);
                });

            const susturl = `${API_BASE_URL}${GET_SUP_STO_DATA}?&PurchaseId=${PurchaseId}`;
            Axios.get(susturl)
                .then(response => {
                    if (response.data.Status) {
                        setStoreSupData(response.data.ResultData[0]);
                        setLoading(false);
                        console.log(response.data.ResultData, 'req details store supp');
                    } else {
                        console.error('Error fetching data:', response.data.Message);
                        setLoading(false);
                    }
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                    setLoading(false);
                });
        }
    
    }, [PurchaseId]);

    // const renderTooltip = (props) => (
    //     <Tooltip id="pdf-tooltip" {...props}>
    //         Pdf
    //     </Tooltip>
    // );

    useEffect(() => {
        if (firstData) {
          // Parse and format PODate
          console.log(firstData, 'ppoobbjj')
          if (firstData.PODate) {
            const poDate = new Date(firstData.PODate);
            const formattedPODate = poDate.toISOString().split("T")[0];
            setFormattedDate(formattedPODate);
          }
        }
      }, [firstData]);

      const [showPDF, setShowPDF] = useState(false);

      const generatePDF = () => {
        setShowPDF(true);
        const element = contentRef.current;
    
        html2pdf()
          .from(element)
          .save("purchase_order.pdf")
          .then(() => {
            setShowPDF(false);
          });
      };

    useEffect(() => {
        let totalTaxAmt = 0;
        let totalAmount = 0;
        let totalQuantity = 0;
    
        if (viewData && viewData.length > 0) {
    
            totalTaxAmt = viewData.reduce((acc, product) => {
                const taxRate = product.CGSTRate + product.SGSTRate;
                const taxAmount = (product.UnitPrice * product.Quantity * taxRate) / 100;
                return acc + (taxAmount || 0);
            }, 0);
    
            totalAmount = viewData.reduce((acc, product) => {
                const amount = product.UnitPrice * product.Quantity;
                return acc + (amount || 0);
            }, 0);

            totalQuantity = viewData.reduce((acc, product) => {
                const qty = product.Quantity;
                return acc + (qty || 0);
            }, 0);
        }
    
        setTaxAmount(totalTaxAmt);
        setAmountWithOutDis((totalAmount + totalTaxAmt));
        setTotalQty(totalQuantity);
        setTotalAmount((totalAmount + totalTaxAmt) - (firstData?.DiscountAmount)); 
    }, [viewData]);

    // useEffect(() => {
    //     const today = new Date();
    //     const month = String(today.getMonth() + 1).padStart(2, '0');
    //     const day = String(today.getDate()).padStart(2, '0');
    //     const year = today.getFullYear();
    
    //     const formattedDate = `${month}/${day}/${year}`;
    //     setCurrentDate(formattedDate);
    // })


    return (
        <div >
            {loading ?
            //  <div className="loader m-auto d-flex"></div> 
            
             <SpinLoader/>
             :
                <div className="container" style={{ width: "100%" , maxWidth: "800px" , margin: "0 auto" }}>
                    <div className="center-image" style={{ textAlign: "center" , margin: "10px" }}>
                        <img src={logo} alt="Purchase Order Image" style={{ width: "150px" , height: "auto" }} />
                    </div>
                    <hr />
            
                    <div className="d-flex" style={{ display: "flex" , justifyContent: "space-between" , alignItems: "flex-start" ,
                        flexWrap: "wrap" , gap: "20px" }}>
                        <h4 style={{ color: "#FF9F43" }}>PURCHASE ORDER</h4>
                        <div>
                            {/* <p >Date: {currentDate}</p> */}
                            <h4 className="text-info">
                                PO - {firstData?.AutoGenTransactionNo || ""}
                            </h4>
                        </div>
                        <div>
                            <h4>Date: {formattedDate}</h4>
                        </div>
                        <div className="ms-auto me-5">
                            {showPDF ? <p>Downloading...</p> : 
                            <div onClick={generatePDF}>
                                <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                            </div>
                            }
                        </div>
                    </div>
            
                    <div className="vendor-shi mb-4 d-flex">
                        <div className="col-6 d-flex flex-column justify-content-between">
                            <h4 className="bg-primary text-white">SUPPLIER DETAILS:</h4>
                            <p>Name: <strong>{storeSupData?.SupplierName || ""}</strong></p>
                            <p>Email: <strong>{storeSupData?.SupplierEmail}</strong></p>
                            <p>Address: <strong>{storeSupData?.SupplierAddress}</strong></p>
                            <p>Phone: <strong>{storeSupData?.SupplierPhno}</strong></p>
                        </div>

                        <div className="col-6 d-flex flex-column justify-content-between">
                            <h4 className="bg-primary text-white">SHIP TO:</h4>
                            <p>Name: <strong>{storeSupData?.StoreName}</strong></p>
                            <p>Company: <strong>{storeSupData?.BusinessName}</strong></p>
                            <p>Email: <strong>{storeSupData?.StoreEmail}</strong></p>
                            <p>Address: <strong>{storeSupData?.StoreAddress}</strong></p>
                            <p>Phone: <strong>{storeSupData?.StorePhoneNo}</strong></p>
                        </div>
                    </div>
                    <div className="table-responsive" style={{ maxHeight: "20rem", overflowY: "auto" }}>
                        <table className="table" style={{ width: "100%", borderCollapse: "collapse", marginBottom: "15px" }}>
                            <thead>
                                <tr>
                                    <th style={{ border: "1px solid #000", textAlign: "left", backgroundColor: "#FF9F43", color: "white" }}>
                                        #
                                    </th>
                                    <th style={{ border: "1px solid #000", textAlign: "left", backgroundColor: "#FF9F43", color: "white" }}>
                                        Product
                                    </th>
                                    <th style={{ border: "1px solid #000", textAlign: "left", backgroundColor: "#FF9F43", color: "white" }}>
                                        Qty
                                    </th>
                                    <th style={{ border: "1px solid #000", textAlign: "left", backgroundColor: "#FF9F43", color: "white" }}>
                                        Price
                                    </th>
                                    <th style={{ border: "1px solid #000", textAlign: "left", backgroundColor: "#FF9F43", color: "white" }}>
                                        Units
                                    </th>
                                    <th style={{ border: "1px solid #000", textAlign: "left", backgroundColor: "#FF9F43", color: "white" }}>
                                        Tax
                                    </th>
                                    <th style={{ border: "1px solid #000", textAlign: "left", backgroundColor: "#FF9F43", color: "white" }}>
                                        Amount
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {viewData.map((item, index) => (
                                <tr key={index}>
                                    <td style={{ border: "1px solid #000" }}>{index + 1}</td>
                                    <td style={{ border: "1px solid #000" }}>{item.ProductName}</td>
                                    <td style={{ border: "1px solid #000" }}>{item.Quantity}</td>
                                    <td style={{ border: "1px solid #000" }}>{item.UnitPrice}</td>
                                    <td style={{ border: "1px solid #000" }}>{item.Units}</td>
                                    <td style={{ border: "1px solid #000" }}>{`${item.CGSTRate + item.SGSTRate}%`}</td>
                                    <td style={{ border: "1px solid #000" }}>
                                    {(
                                        (item.Quantity || 0) * (item.UnitPrice || 0) +
                                        (((item.CGSTRate || 0) + (item.SGSTRate || 0)) / 100) * (item.Quantity || 0) * (item.UnitPrice || 0)
                                    ).toFixed(2)}
                                    </td>
                                </tr>
                                ))}
                            </tbody>
                            <tfoot>
                                <tr>
                                <td colSpan="2" style={{ textAlign: "right", fontWeight: "bold" }}>Total Qty:</td>
                                <td>{totalQty}</td>
                                <td colSpan="3" style={{ textAlign: "right", fontWeight: "bold" }}>Total Amount:</td>
                                <td>{amountWithOutDis}</td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>

                    <table className="table table-bordered" style={{ width: "100%" }}>
                        <tbody>
                            <tr>
                                <td style={{ textAlign: "left" }}>Total Discount</td>
                                <th className="text-end">
                                    {Number(firstData?.DiscountAmount || 0).toFixed(2)}
                                </th>
                            </tr>
                            <tr>
                                <td style={{ textAlign: "left" }}>Total Tax</td>
                                <th className="text-end">
                                    {Number(taxAmount || 0).toFixed(2)}
                                </th>
                            </tr>
                            <tr>
                                <td>
                                    <strong>Total Amount</strong>
                                </td>
                                <th className="text-end">{Number(totalAmount || 0).toFixed(2)}</th>
                            </tr>
                        </tbody>
                    </table>

                    <div className="comments col-12 col-md-6 mt-3" style={{ backgroundColor: "#f0f0f0" , padding: "10px" , }}>
                        <p>
                            <strong>Comments or Special Instructions:</strong>
                        </p>
                        <p>Thank you for your business.</p>
                    </div>
                    <div className="footer" style={{ fontSize: "12px" , textAlign: "center" , color: "gray" , marginTop: "20px" ,
                        }}>
                        <p>If you have any questions about this purchase order, please contact +91 98235342230</p>
                    </div>
                </div>
            }

            {/* print content */}
                <div ref={contentRef} className={`container ${showPDF ? 'd-block' : 'd-none'}`} style={{ width: "100%" , maxWidth: "800px" , margin: "0 auto" }}>
                    <div className="center-image" style={{ textAlign: "center" , margin: "10px" }}>
                        <img src={logo} alt="Purchase Order Image" style={{ width: "150px" , height: "auto" }} />
                    </div>
                    <hr />
            
                    <div className="d-flex" style={{ display: "flex" , justifyContent: "space-between" , alignItems: "flex-start" ,
                        flexWrap: "wrap" , gap: "20px" , paddingLeft: "15px" , }}>
                        <h1 style={{ textAlign: "left" , color: "#FF9F43" }}>PURCHASE ORDER</h1>
                        <div>
                            {/* <p style={{ margin: 0 }}>Date: {currentDate}</p> */}
                            <h2 style={{ textAlign: "left" , color: "#FF9F43" , margin: 0 }}>
                                PO - {firstData?.AutoGenTransactionNo || ""}
                            </h2>
                        </div>
                    </div>
            
                    <div className="vendor-shi mb-4 d-flex">
                        <div className="col-6 d-flex flex-column justify-content-between">
                            <h4 className="bg-primary text-white">SUPPLIER DETAILS:</h4>
                            <p>Name: <strong>{storeSupData?.SupplierName || ""}</strong></p>
                            <p>Email: <strong>{storeSupData?.SupplierEmail}</strong></p>
                            <p>Address: <strong>{storeSupData?.SupplierAddress}</strong></p>
                            <p>Phone: <strong>{storeSupData?.SupplierPhno}</strong></p>
                        </div>

                        <div className="col-6 d-flex flex-column justify-content-between">
                            <h4 className="bg-primary text-white">SHIP TO:</h4>
                            <p>Name: <strong>{storeSupData?.StoreName}</strong></p>
                            <p>Company: <strong>{storeSupData?.BusinessName}</strong></p>
                            <p>Email: <strong>{storeSupData?.StoreEmail}</strong></p>
                            <p>Address: <strong>{storeSupData?.StoreAddress}</strong></p>
                            <p>Phone: <strong>{storeSupData?.StorePhoneNo}</strong></p>
                        </div>
                    </div>
            
                    <div className="table-responsive" >
                        <table className="table" style={{ width: "100%" , borderCollapse: "collapse" , marginBottom: "15px" , }}>
                            <thead>
                                <tr>
                                    <th style={{ border: "1px solid", backgroundColor: "#FF9F43", textAlign: "left", color: "white" , }}>
                                        #
                                    </th>
                                    <th style={{ border: "1px solid", backgroundColor: "#FF9F43", textAlign: "left", color: "white" , }}>
                                        Product
                                    </th>
                                    <th style={{ border: "1px solid", backgroundColor: "#FF9F43", textAlign: "left", color: "white" , }}>
                                        Qty
                                    </th>
                                    <th style={{ border: "1px solid", backgroundColor: "#FF9F43", textAlign: "left", color: "white" , }}>
                                        Price
                                    </th>
                                    <th style={{ border: "1px solid", backgroundColor: "#FF9F43", textAlign: "left", color: "white" , }}>
                                        Units
                                    </th>
                                    <th style={{ border: "1px solid", backgroundColor: "#FF9F43", textAlign: "left", color: "white" , }}>
                                        Tax
                                    </th>
                                    <th style={{ border: "1px solid", backgroundColor: "#FF9F43", textAlign: "left", color: "white" , }}>
                                        Amount
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {viewData.map((item, index) => (
                                <tr key={item.index}>
                                    <td style={{ border: "1px solid #000"  }}>
                                        {index + 1}
                                    </td>
                                    <td style={{ border: "1px solid #000"  }}>
                                        {item.ProductName}
                                    </td>
                                    <td style={{ border: "1px solid #000"  }}>
                                        {item.Quantity}
                                    </td>
                                    <td style={{ border: "1px solid #000"  }}>
                                        {item.UnitPrice}
                                    </td>
                                    <td style={{ border: "1px solid #000"  }}>
                                        {item.Units}
                                    </td>
                                    <td style={{ border: "1px solid #000"  }}>
                                        {`${item.CGSTRate + item.SGSTRate}%`}
                                    </td>
                                    <td style={{ border: "1px solid #000"  }}>
                                        {(
                                        (item.Quantity || 0) * (item.UnitPrice || 0) +
                                        (((item.CGSTRate || 0) + (item.SGSTRate || 0)) / 100) *
                                        (item.Quantity || 0) *
                                        (item.UnitPrice || 0)
                                        ).toFixed(2)}
                                    </td>
                                </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <table className="table table-bordered" style={{ width: "100%" }}>
                        <tbody>
                            <tr>
                                <td className="text-start">Total Discount</td>
                                <th className="text-end fw-bold">
                                    {Number(firstData?.DiscountAmount || 0).toFixed(2)}
                                </th>
                            </tr>
                            <tr>
                                <td className="text-start">Total Tax</td>
                                <th className="text-end fw-bold">
                                    {Number(taxAmount || 0).toFixed(2)}
                                </th>
                            </tr>
                            <tr>
                                <td>
                                    <strong>Total Amount</strong>
                                </td>
                                <th className="text-end">{Number(totalAmount || 0).toFixed(2)}</th>
                            </tr>
                        </tbody>
                    </table>

                    <div className="comments col-12 col-md-6 mt-3" style={{ backgroundColor: "#f0f0f0" , padding: "10px" , }}>
                        <p>
                            <strong>Comments or Special Instructions:</strong>
                        </p>
                        <p>Thank you for your business.</p>
                    </div>
                    <div className="footer" style={{ fontSize: "12px" , textAlign: "center" , color: "gray" , marginTop: "20px" ,
                        }}>
                        <p>If you have any questions about this purchase order, please contact +91 9866954660</p>
                    </div>
                </div>
        </div>
      
    )
}



export default ViewDataToSupplier;
